import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';

import { getCustomerDetails, getCustomerList, logCustomerHistory, getSalesOrderList } from '../../../services/index';
import toast, { Toaster } from 'react-hot-toast';
import EditIcon from '@mui/icons-material/Edit';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import SearchRoundedIcon from '@mui/icons-material/SearchRounded';
import AddIcon from '@mui/icons-material/Add';
import { getInvoiceRecordsByCustomerId } from '../../../services/Sales/CustomerService';

const CustomerView = (props) => {
    let navigate = useNavigate();
    let { id } = useParams();
    const [tabIndex, setTabIndex] = useState(0);
    const [salesList, setSalesList] = useState([]);
    const [invoiceList, setInvoiceList] = useState([]);
    const [cid, setCid] = useState('');

    const [invoiceInfo, setInvoiceInfo] = useState([]);
    const [salesInfo, setSalesInfo] = useState([]);

    const [logData, setLogData] = useState({});
    const [rows, setRows] = useState([]);
    const [rows2, setRows2] = useState([]);
    const [customerDetails, setCustomerDetails] = useState([]);
    const [dataid, setDataid] = useState();
    const [customerListDetails,setCustomerListDetails] = useState(null);
    const [index, setIndex] = useState(0);
    const [filterText, setFilterText] = useState("");


    const getRecordsid = (id) => {
        setTabIndex(0);
        // setInvoiceInfo(null);
        setCid(id);
        getCustomerDetails(id).then((res) => {
            if (res.errorCode === 0) {
                let d = res.responsePacket;
                setCustomerDetails(d);

                d.addressList.map((a) => {
                    if (a.addressType === 'Billing') {
                        d.billAdd = a;
                    }

                    if (a.addressType === 'Shipping') {
                        d.shipAdd = a;
                    }
                });
            } else {
                toast.error(res.message);
            }
        });
    };

    const editItems = () => {
        navigate(`/contacts/${customerDetails.recordId}/edit`);
        setDataid(customerDetails.recordId);
    };
    useEffect(() => {
        logCustomerHistory(id).then((res) => {
            if (res.errorCode === 0) {
                const d = res.responsePacket;
                setLogData(d);
            } else {
                toast(res.message);
            }
        });

        // let abc = salesList.filter((a) => a.customerid === cid);
        // console.log(abc)
        // setSalesInfo(abc);
    }, [props?.includes?.params.id]);


    const getAllCustomerRecords = () => {
        let Customer_data = {
            page: index,
            size: 15,
            search: filterText,
        };
        getCustomerList(Customer_data).then((res) => {
            if (res.errorCode === 0) {
                if (index === 0) {
                    const d = res.responsePacket.data;
                    setRows(d);
                    setRows2(d);
                } else {
                    const setCustomerClone = [...rows, ...res.responsePacket.data];
                    setRows(setCustomerClone);
                    setRows2(setCustomerClone);
                }
                setIndex(index + 1);
                setCustomerListDetails({
                    recordsFiltered: res.responsePacket.recordsFiltered,
                    recordsTotal: res.responsePacket.recordsTotal,
                    total: res.responsePacket.total,
                })
            } else {
                toast(res.message);
            }
        });
    };
 

      useEffect(() => {
        getAllCustomerRecords();
        getRecordsid(id);
    }, [id]);


    useEffect(() => {
        getAllCustomerRecords();
    }, [filterText])

    let time;
    const handleSearch = (e) => {
        const { value } = e.target;
        clearTimeout(time);
        time = setTimeout(() => {
            setIndex(0);
            setFilterText(value);
        }, 500);
    };

    const checkIfDueDateExceeded = (dueDate, invoiceDate) => {
        const dueDt = new Date(dueDate);
        const invDt = new Date(invoiceDate);
        if (dueDt.getTime() > invDt.getTime()) {
            return true;
        }
        return false;
    };

    return (
        <>
            <div className='list-column column d-print-none' style={{ width: '300px' }}>
                <div className="fill list-header topgrad d-print-none">
                    <div className="list-filter pt-3 d-flex align-items-center">
                        <Link to="/contacts/new" className="newListBtn">
                            <AddIcon />
                            New
                        </Link>
                        <div className='input-group paginationSearchInput listSearch'>
                            <div className='input-group-prepend'>
                                <span className='input-group-text' id='basic-addon1'>
                                    <SearchRoundedIcon />
                                </span>
                            </div>
                            <input autoComplete='off' className='form-control' type='text' placeholder='Search...' onChange={handleSearch} />
                        </div>
                    </div>
                </div>

                <div className='scroll-y fill body scrollbox list-body'>
                    <div className='table-responsive overflow-initial'>
                        <table id='ember7912' className='table zi-table table-hover ember-view header-fixed'>
                            {(rows && rows.length > 0) ? 
                            (<tbody>
                                {rows.map((row, i) => (
                                    <tr key={i} className={`listTr ${id === row.recordId ? 'activeRecord' : ''}`} onClick={() => getRecordsid(row.recordId)}>
                                        <td>
                                            <Link to={`/contacts/${row.recordId}`} className={`${id === row.recordId ? 'text-primary' : 'text-grey'}`}>
                                                <span className='titleTr'>{row.title}</span>
                                                <span className='text-muted d-block'>Phone: {row?.phone}</span>
                                            </Link>
                                        </td>
                                    </tr>
                                ))}
                                {
                                        customerListDetails &&
                                        customerListDetails.recordsTotal >
                                        rows.length && (
                                            <div className="pt-3">
                                                <button
                                                    className="btn mx-auto newListBtn"
                                                    onClick={getAllCustomerRecords}
                                                >
                                                    Load More
                                                </button>
                                            </div>

                                        )}
                            </tbody>) : (<div className="my-3 text-black text-center">No Data Available!</div>)
                              }
                        </table>
                    </div>
                </div>
            </div>

            <div className='column content-column ' style={{ left: '301px' }}>
                <div className='header no-border d-flex align-items-center p-4'>
                    <a className='over-flow header-title text-uppercase' style={{ fontSize: 'x-large' }}>
                        &nbsp;
                    </a>
                    <div className='btn-toolbar d-flex justify-content-end align-items-center'>
                        <button className='tooltip-container ember-view btn btn-primary mr-2' onClick={editItems}>
                            <EditIcon />
                        </button>
                    </div>
                </div>
                <Tabs selectedIndex={tabIndex} onSelect={(index) => setTabIndex(index)} className='upperTabs'>
                    <TabList>
                        <Tab>Primary Details</Tab>
                        <Tab>Log History</Tab>
                        {/* <Tab>Sales Info</Tab> */}
                        {/* <Tab>Invoice Info</Tab> */}
                    </TabList>
                    <TabPanel>
                        <br />
                        <div className="ember-view scroll-y noscroll-x fill body scrollbox pb-0 ">
                        {customerDetails && customerDetails ? (
                            <div className="customTable" id="scroll" style={{height:"81vh",maxHeight:"none"}}>
                            <table>
                                <tbody>
                                    <tr>
                                        <td>Name:</td>
                                        <td>{customerDetails.title}</td>
                                    </tr>
                                    <tr>
                                        <td>Phone:</td>
                                        <td>{customerDetails.phone}</td>
                                    </tr>
                                    <tr>
                                        <td>Email:</td>
                                        <td>{customerDetails.email}</td>
                                    </tr>
                                    <tr>
                                        <td>GST:</td>
                                        <td>{customerDetails.gstNumber}</td>
                                    </tr>
                                    <tr>
                                        <td>FSSAI:</td>
                                        <td>{customerDetails.fssaiLicenseNumber}</td>
                                    </tr>
                                    <tr>
                                        <td>PriceList:</td>
                                        <td>{customerDetails.itemPriceListTitle}</td>
                                    </tr>

                                    <tr>
                                        <td>Payment Term:</td>
                                        <td>
                                            {customerDetails?.paymentTermTitle}&nbsp;(
                                            {customerDetails?.paymentTermDays})
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Discount:</td>
                                        <td>
                                            {customerDetails.discountType}&nbsp;
                                            {customerDetails.discountValue}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Place Of Supply:</td>
                                        <td>{customerDetails.placeOfSupplyTitle}</td>
                                    </tr>
                                    <tr>
                                        <td>Billing Address:</td>
                                        <td>{customerDetails.billAdd?.addressLine1}</td>
                                    </tr>
                                    <tr>
                                        <td></td>
                                        <td>{customerDetails.billAdd?.addressLine2}</td>
                                    </tr>
                                    <tr>
                                        <td></td>
                                        <td>
                                            {customerDetails.billAdd?.city}&nbsp;
                                            {customerDetails.billAdd?.state}&nbsp;
                                            {customerDetails.billAdd?.pinCode}&nbsp;
                                            {customerDetails.billAdd?.country}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Shipping Address:</td>
                                        <td>{customerDetails.shipAdd?.addressLine1}</td>
                                    </tr>
                                    <tr>
                                        <td></td>
                                        <td>{customerDetails.shipAdd?.addressLine2}</td>
                                    </tr>
                                    <tr>
                                        <td></td>
                                        <td>
                                            {customerDetails.shipAdd?.city}&nbsp;
                                            {customerDetails.shipAdd?.state}&nbsp;
                                            {customerDetails.shipAdd?.pinCode}&nbsp;
                                            {customerDetails.shipAdd?.country}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            </div>
                        ) : (
                            <></>
                        )}
                        </div>
                    </TabPanel>
                    <TabPanel>
                        <div className='ember-view scroll-y noscroll-x fill body scrollbox'>
                        <table>
                            {logData.length === 0 ? (
                                'No Changes Found'
                            ) : (
                                <thead>
                                    <tr>
                                        <th>Date</th>
                                        <th>Changes</th>
                                    </tr>
                                </thead>
                            )}
                            {logData.length >= 1 && (
                                <tbody>
                                    {logData?.map((history, i) => {
                                        return (
                                            <tr key={i}>
                                                <td style={{ verticalAlign: 'top', width: '80px' }}>
                                                    {history?.transactionDate?.substring(0, 10)}
                                                    :&nbsp;&nbsp;
                                                    <br />
                                                    Time:
                                                    {history?.transactionDate?.split('T')[1]?.substring(0, 5)}
                                                </td>

                                                <td>
                                                    <div dangerouslySetInnerHTML={{ __html: history?.message.replaceAll("\n", "<br />").replaceAll("\t", "&nbsp;&nbsp;&nbsp;&nbsp;") }} />
                                                    {/* {history?.message.split('\n').map((b, j) => (
                                                        <div key={j}>
                                                            {b.includes('\t') ? <div style={{ marginLeft: '20px' }}>{b}</div> : b.includes('\t\t') ? <div style={{ marginLeft: '40px' }}>{b}</div> : b}
                                                        </div>
                                                    ))} */}
                                                </td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            )}
                        </table>
                        </div>
                    </TabPanel>

                    {/* <TabPanel>
                        {salesInfo.length > 0 ? (
                            <>
                                <div style={{ overflowY: 'scroll', height: '80vh' }}>
                                    <table className='customTable'>
                                        <thead>
                                            <tr>
                                                <td>Sales No.</td>
                                                <td>Date</td>
                                                <td>Total</td>
                                            </tr>
                                        </thead>
                                        {salesInfo && (
                                            <tbody>
                                                {salesInfo.map((a,i) => {
                                                    return (
                                                        <tr key={i}>
                                                            <td>
                                                                <Link to={`/salesorders/${a.recordId}`} target='_blank'>
                                                                    {a.orderNo}
                                                                </Link>
                                                            </td>
                                                            <td>{a.salesOrderDate}</td>
                                                            <td>₹ {a.totalAmount}</td>
                                                        </tr>
                                                    );
                                                })}
                                            </tbody>
                                        )}
                                    </table>
                                </div>
                            </>
                        ) : (
                            'No SalesOrder for this customer'
                        )}
                    </TabPanel> */}

                    {/* <TabPanel>
                        {invoiceInfo && invoiceInfo.length > 0 ? (
                            <>
                                <div style={{ overflowY: 'scroll', height: '80vh' }}>
                                    <table className='customTable'>
                                        <thead>
                                            <tr>
                                                <td>Sales No.</td>
                                                <td>Invoice No.</td>
                                                <td>Date</td>
                                                <td>Total</td>
                                                <td>Due Date</td>
                                            </tr>
                                        </thead>
                                        {invoiceInfo && (
                                            <tbody>
                                                {invoiceInfo.map((a,i) => {
                                                    return (
                                                        <tr key={i}>
                                                            <td>{a.salesOrderNo}</td>
                                                            <td>
                                                                <Link to={`/invoices/${a.recordId}`} target='_blank'>
                                                                    {a.invoiceNo}
                                                                </Link>
                                                            </td>
                                                            <td>{a.invoiceDate}</td>
                                                            <td>₹ {a.amount}</td>
                                                            <td className={`${checkIfDueDateExceeded(a.dueDate, a.invoiceDate) ? 'text-danger' : ''}`}>{a.dueDate}</td>
                                                        </tr>
                                                    );
                                                })}
                                            </tbody>
                                        )}
                                    </table>
                                </div>
                            </>
                        ) : (
                            'No invoice for this customer'
                        )}
                    </TabPanel> */}
                </Tabs>
            </div>
            <Toaster />
        </>
    );
};

export default CustomerView;
